import React from "react";
import HeroSection from "../components/layout/HeroSection";
// import AboutCompany from "../components/AboutCompany";
import ServiceArea from "../components/ServiceArea";
import WorkArea from "../components/WorkArea";
// import ProjectArea from "../components/ProjectArea";
import PricingArea from "../components/PricingArea";
import Testimonils from "../components/Testimonils";
// import BlogsAndLatestNews from "../components/BlogsAndLatestNews";
import CtaArea from "../components/CtaArea";
import ProblemUserface from "../components/ProblemUserface";
// import SolutionsIBRLive from "../components/SolutionsIBRLive";

const Home = () =>{
    return(
       <>
       <HeroSection/>
       <ProblemUserface/>
       {/* <SolutionsIBRLive/> */}
       {/* <AboutCompany/> */}
       <ServiceArea/>
       <PricingArea priceExcludesGst />
       <WorkArea/>
       {/* <ProjectArea/> */}
       {/* <BlogsAndLatestNews/> */}
       <Testimonils/>
       <CtaArea/>
       </>
    )
}

export default Home;